'use strict';

export default function SearchListItem({
    item: {id, aircraft, routes, prices, is_emptyleg}, 
    imageSize,
    averagePrice,
    isInCompare,
    isCompareInitiator,
    showPriceModal = false,
    onClick,
    onCompareClick,
    onShowBarometerClick,
}) {
    
    const handleClick = (id) => {
        onClick && onClick(id)
    }    
    
    const handleBarometerClick = () => {
        onShowBarometerClick && onShowBarometerClick()
    }
    
    const format = (date, format_from = 'DD.MM.YY', format_to = "DD.MM.YYYY") => {
        if (!window.moment) return;
        const moment = window.moment(date, format_from)
        if (!moment.isValid()) return '';
        return moment.format(format_to)
    }
    
    const isPriceBelowAnnual = () => {
        if (!averagePrice || !prices.price || isNaN(averagePrice) || isNaN(prices.price)) return false;
        return prices.price < averagePrice
    }

    const image = aircraft.images && aircraft.images[imageSize] && aircraft.images[imageSize].length > 0 ? aircraft.images[imageSize][0] : null
    
    return <div className="flight">
        
        <a role='button' className="flight-link" onClick={() => handleClick(id)}></a>
        
        <div className="flight-img">
            <img src={image || ''} alt=""/>
        </div>
        <div className="flight-desc">
            <div className="el-flight-title">
                <h3>
                    {aircraft.title}
                    <span> </span>
                    {is_emptyleg && <sup className="el-tooltip" data-tooltip="Empty Leg"> el</sup>}
                </h3>
                <a role='button' className={cn("el-flight-compare", isInCompare && 'added')} disabled={!isCompareInitiator} onClick={onCompareClick}>
                    <i className="icon-compare3"></i>
                    {tMsg(isInCompare ? 'Выбрано' : 'Сравнить')}
                </a>
            </div>
            <div className="flight-planes">
                <div>
                    {!!aircraft.year ? aircraft.year + ' ' : ''}
                    {!!aircraft.update && <i className="el-tooltip" data-tooltip={tMsg('Обновление салона')}>
                        {`(${aircraft.update})`}
                    </i>}
                </div>
                <div>{aircraft.class.title}</div>
            </div>
            <div className="flight-row">
                <div className="flight-info">
                    <span>{tMsg('Мест')}</span>
                    {aircraft.params.seats}
                </div>
                <div className="flight-info">
                    <span>{tMsg('Выс.салона')}</span>
                    {aircraft.params.height}
                </div>
                <div className="flight-info">
                    <span>{tMsg('Багаж')}</span>
                    {aircraft.facilities.baggage}
                </div>
                <div className="flight-info">
                    <span>{tMsg('Питание')}</span>
                    {aircraft.facilities.food}
                </div>
                <div className="flight-info">
                    <span>{tMsg('Стюардесса')}</span>
                    {aircraft.facilities.stewardess}
                </div>
            </div>
        </div>
        <div className="flight-control">
            {showPriceModal && <div className="flight-price__info">
                <a type="button" className="flight-price__graph-link" onClick={handleBarometerClick}>
                    {isPriceBelowAnnual() && <React.Fragment>
                        <i className="icon-down4"></i>
                        <span>{tMsg('Цена ниже среднегодовой')}</span>
                    </React.Fragment>}
                    {!isPriceBelowAnnual() && <React.Fragment>
                        <i className="icon-quesion"></i>
                        <span dangerouslySetInnerHTML={{__html: tMsg('Подробнее <br/> о цене')}}/>
                    </React.Fragment>}
                </a>
            </div>}
            {routes.map(({from, to, departDate, departDateFrom, departDateTo}) => {
                const showDepartDateTo = !!departDateTo && departDateFrom != departDateTo;
                return <div key={`routes${id}${from}${to}${departDate}${departDateFrom}${departDateTo}`} className="el-flight__direction">
                    <div className="el-flight__direction-way">
                        {!!from && <div>{from.city}</div>}
                        {!!to && <div><span>→</span> {to.city}</div>}
                    </div>
                    <div className="el-flight__direction-date">
                        {!!departDate && <div>{format(departDate)}</div>}
                        {!!departDateFrom && <div>{format(departDateFrom)} {showDepartDateTo && '—'}</div>}
                        {!!showDepartDateTo && <div>{format(departDateTo)}</div>}
                    </div>
                </div>
            })}
            <div className="flight-price">
                {prices.prefix}{prices.price_pretty} {prices.currency.symbol}
            </div>
        </div>
    </div>
}